import { render } from "./ProductRegistrationFindBike.vue?vue&type=template&id=22063dc1"
import script from "./ProductRegistrationFindBike.vue?vue&type=script&lang=js"
export * from "./ProductRegistrationFindBike.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__